var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorMatchLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 868,
    viewBox: "0 0 140 868",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 10L110 10C54.7715 10 10 54.7715 10 110L10 868",
    stroke: "#BCB2FF",
    strokeOpacity: 0.1,
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorMatchLines);
export default __webpack_public_path__ + "static/media/MentorMatchLines.c365da985384a0963c0bd1d626d9fdc7.svg";
export { ForwardRef as ReactComponent };